import { Link } from 'gatsby'
import React from 'react'

import criticalCare from '../img/icons/icn_critical_care.svg'
import diabetesCare from '../img/icons/icn_diabetes_care.svg'
import doctorConsultation from '../img/icons/icn_doctor_consultation.svg'
import elderCare from '../img/icons/icn_elder_care.svg'
import labTests from '../img/icons/icn_lab_tests.svg'
import medicalEquipment from '../img/icons/icn_medical_equipment.svg'
import physiotherapy from '../img/icons/icn_physiotherapy.svg'
import nursing from '../img/icons/icn_nursing.svg'
import trainedAttendants from '../img/icons/icn_trained_attendant.svg'
import knr from '../img/icons/icn_mother_baby_care.svg'
import vaccination from '../img/icons/icn_vaccination.svg'
import nutrition from '../img/icons/icn_nutrition.svg'
import counselling from '../img/icons/icn_counselling.svg'
import Covid from '../img/icons/icn_covid.svg'

const iconMapping = {
  'Covid Care': { logo: Covid, page: 'coronavirus/' },
  'Critical Care': { logo: criticalCare, page: 'critical-care/' },
  'Diabetes Care': { logo: diabetesCare, page: 'diabetes-care/' },
  'Elder Care': { logo: elderCare, page: 'elder-care/' },
  'Doctor Consultation': {
    logo: doctorConsultation,
    page: 'doctor-consultations/',
  },
  Physiotherapy: { logo: physiotherapy, page: 'physiotherapy/' },
  'Medical Equipment': {
    logo: medicalEquipment,
    page: 'medical-equipment/',
  },
  'Lab Tests': { logo: labTests, page: 'diagnostic/' },
  Nursing: { logo: nursing, page: 'nursing/' },
  'Trained Attendants': {
    logo: trainedAttendants,
    page: 'trained-attendants/',
  },
  'Mother & Baby Care': {
    logo: knr,
    page: 'new-born-baby-mother-care/',
  },
  Vaccination: { logo: vaccination, page: 'vaccination/' },
  'Nutrition & Diet Consultation': {
    logo: nutrition,
    page: 'nutrition-diet-consultation/',
  },
  Counselling: { logo: counselling, page: 'counselling/' },
}

export const serviceIconLookup = (service) => iconMapping[service].logo

export const servicePageLookup = (service) => iconMapping[service].page

export const prepareLinkElement = (url, display, elemClass) => {
  const link = new URL(url, 'https://www.portea.com')
  const pathName = link.pathname

  if (
    [
      '/physiotherapy',
      '/nursing',
      '/vaccination',
      '/elder-care',
      '/doctor-consultations',
      '/diabetes-care',
      '/trained-attendants',
    ].some((p) => pathName.startsWith(p))
  ) {
    return (
      <Link key={display} className={elemClass || ''} to={pathName}>
        {display}
      </Link>
    )
  }

  return (
    <a key={display} className={elemClass || ''} href={url}>
      {display}
    </a>
  )
}
